import { render, staticRenderFns } from "./imageModal.vue?vue&type=template&id=6b8e4124&scoped=true&"
import script from "./imageModal.vue?vue&type=script&lang=js&"
export * from "./imageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8e4124",
  null
  
)

export default component.exports